<template>
	<div class>
		<b-modal centered id="modal-add-highlight" @hidden="onReset" ref="modalAddHighlight"  body-class="d-flex"
			size="md" hide-footer hide-header>
			<div class="modal-container w-100">
				<Spinner v-if="loadingStatus" text="Retrieving data..." classes="text-dark-8 mh-60" spinner-color="var(--c-dark-8)"
      spinner-size="15px" />
	  <div v-else-if="allInOneStreams.length === 0">
	  <b-row class="text-center px-3 mb-3">
		<b-col>
			<svg class="mb-3" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
			<path d="M15.5 4H10.5C6.99967 4 5.24951 4 3.91256 4.68121C2.73655 5.28042 1.78042 6.23655 1.18121 7.41256C0.5 8.74951 0.5 10.4997 0.5 14V18C0.5 21.5003 0.5 23.2505 1.18121 24.5874C1.78042 25.7635 2.73655 26.7196 3.91256 27.3188C5.24951 28 6.99967 28 10.5 28H15.5C19.0003 28 20.7505 28 22.0874 27.3188C23.2635 26.7196 24.2196 25.7635 24.8188 24.5874C25.5 23.2505 25.5 21.5003 25.5 18V14C25.5 10.4997 25.5 8.74951 24.8188 7.41256C24.2196 6.23655 23.2635 5.28042 22.0874 4.68121C20.7505 4 19.0003 4 15.5 4Z" fill="#4F5C87"/>
			<path d="M34.5 22.7104V9.28958C34.5 8.30062 33.4059 7.70332 32.5741 8.23811L25.0741 13.0595C24.7163 13.2895 24.5 13.6857 24.5 14.111V17.889C24.5 18.3143 24.7163 18.7105 25.0741 18.9405L32.5741 23.7619C33.4059 24.2967 34.5 23.6994 34.5 22.7104Z" fill="#485377"/>
			<path d="M30.5 39C34.9183 39 38.5 35.4183 38.5 31C38.5 26.5817 34.9183 23 30.5 23C26.0817 23 22.5 26.5817 22.5 31C22.5 35.4183 26.0817 39 30.5 39Z" fill="#E25858"/>
			<path d="M31.908 30.9991L34.2046 28.712C34.2977 28.6189 34.3716 28.5083 34.422 28.3866C34.4724 28.265 34.4983 28.1345 34.4983 28.0029C34.4983 27.8712 34.4724 27.7407 34.422 27.6191C34.3716 27.4974 34.2977 27.3869 34.2046 27.2937C34.1115 27.2006 34.001 27.1267 33.8794 27.0763C33.7577 27.0259 33.6273 27 33.4957 27C33.364 27 33.2336 27.0259 33.112 27.0763C32.9903 27.1267 32.8798 27.2006 32.7867 27.2937L30.5 29.5909L28.2133 27.2937C28.1202 27.2006 28.0097 27.1267 27.888 27.0763C27.7664 27.0259 27.636 27 27.5043 27C27.3727 27 27.2423 27.0259 27.1206 27.0763C26.999 27.1267 26.8885 27.2006 26.7954 27.2937C26.7023 27.3869 26.6284 27.4974 26.578 27.6191C26.5276 27.7407 26.5017 27.8712 26.5017 28.0029C26.5017 28.1345 26.5276 28.265 26.578 28.3866C26.6284 28.5083 26.7023 28.6189 26.7954 28.712L29.092 30.9991L26.7954 33.2863C26.7018 33.3792 26.6275 33.4896 26.5768 33.6113C26.5261 33.7331 26.5 33.8636 26.5 33.9954C26.5 34.1273 26.5261 34.2578 26.5768 34.3795C26.6275 34.5013 26.7018 34.6117 26.7954 34.7046C26.8882 34.7982 26.9986 34.8725 27.1203 34.9232C27.242 34.9739 27.3725 35 27.5043 35C27.6362 35 27.7667 34.9739 27.8884 34.9232C28.01 34.8725 28.1205 34.7982 28.2133 34.7046L30.5 32.4074L32.7867 34.7046C32.8795 34.7982 32.99 34.8725 33.1116 34.9232C33.2333 34.9739 33.3638 35 33.4957 35C33.6275 35 33.758 34.9739 33.8797 34.9232C34.0014 34.8725 34.1118 34.7982 34.2046 34.7046C34.2982 34.6117 34.3725 34.5013 34.4232 34.3795C34.4739 34.2578 34.5 34.1273 34.5 33.9954C34.5 33.8636 34.4739 33.7331 34.4232 33.6113C34.3725 33.4896 34.2982 33.3792 34.2046 33.2863L31.908 30.9991Z" fill="#FAFAFB"/>
			</svg>
			<h3 class="text-s-m mb-2 text-500">You don't have any livestreams</h3>
			<p class="text-s-s text-dark-9 mb-1 text-400">Please create a livestream</p>
		</b-col>
	</b-row>
	  	<b-row class="px-3 mt-3">
					<b-col>
						<div style="max-width: 300px;margin-left:auto;margin-right: 0;">
							<div class="text-center d-flex align-items-center justify-content-end mt-3 create-highlight">
								<b-button variant="outline-secondary" size="md" class="w-100 mb-0 mb-md-0 mr-2"
									@click="closeModal">
									Cancel
								</b-button>
								<b-button  variant="primary" size="md" to="/dashboard" class="w-auto mt-0">
									Go to Livestreams
								</b-button>
							</div>
						</div>
					</b-col>
				</b-row>
	  </div>
	  <div v-else>
				<b-row class=" px-3 mb-3">
					<b-col>
						<h3 class="text-s-m mb-2 text-500">New Live Clipping</h3>
						<p class="text-s-s text-dark-9 mb-1 text-400">Choose a stream and highlight a moment.</p>
					</b-col>
				</b-row>
				<b-row class="highlight-quota-exceeded" v-if="isAccessHighlight && (highlight.length >= isAccessHighlight)">
					<b-col class="d-flex algn-items-start justify-content-start">
						<svg class="mr-2 mt-1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M5.36963 3.79666C6.53114 1.6786 7.1119 0.619568 8.00006 0.619568C8.88823 0.619568 9.46898 1.6786 10.6305 3.79666L14.0639 10.0575C15.15 12.0381 15.6931 13.0285 15.2575 13.7642C14.8218 14.5 13.6923 14.5 11.4334 14.5H4.56671C2.30779 14.5 1.17833 14.5 0.742676 13.7642C0.307027 13.0285 0.850109 12.0381 1.93627 10.0575L5.36963 3.79666ZM8.00002 4.74998C8.41424 4.74998 8.75002 5.08577 8.75002 5.49998V7.99998C8.75002 8.41419 8.41424 8.74998 8.00002 8.74998C7.58581 8.74998 7.25002 8.41419 7.25002 7.99998V5.49998C7.25002 5.08577 7.58581 4.74998 8.00002 4.74998ZM8.00006 12C8.55235 12 9.00006 11.5523 9.00006 11C9.00006 10.4477 8.55235 9.99999 8.00006 9.99999C7.44778 9.99999 7.00006 10.4477 7.00006 11C7.00006 11.5523 7.44778 12 8.00006 12Z" fill="#FAFAFB"/>
						</svg>
						<p class="text-s-ss mb-0 text-white mb-1 text-400">Maximum quota for Live Clipping has been reached. Please <span class="text-underline cursor-pointer" onclick="Intercom('show')">contact sales</span>.</p>
					</b-col>
				</b-row>
				<b-row class="px-3 mb-2">
					<b-col>
						<label class="text-dark-9 text-500 text-s-ss mb-2">
							Live clipping name
						</label>
						<b-input v-model="highlightName" class="input" placeholder="Live clipping name" />
					</b-col>
				</b-row>
                <b-row class="px-3">
                    <b-col class="positiom-relative">
						<label class="text-dark-9 text-s-ss text-500 mb-2">
							Streams
						</label>
                        <div class="selected-stream--name text-s-ss text-400" :class="{'stream-selected':this.selectedAIO}">
							<svg v-if="this.selectedAIO" class="mr-2" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M4.9999 2.39999H4.97411C4.29592 2.39999 3.75045 2.39998 3.30905 2.43605C2.85506 2.47314 2.4586 2.55135 2.09253 2.73787C1.50923 3.03508 1.03499 3.50932 0.737783 4.09262C0.55126 4.45869 0.473048 4.85516 0.435956 5.30914C0.399892 5.75054 0.399897 6.29601 0.399902 6.9742V6.99999V8.99999V9.02579C0.399897 9.70397 0.399892 10.2495 0.435956 10.6908C0.473048 11.1448 0.55126 11.5413 0.737783 11.9074C1.03499 12.4907 1.50923 12.9649 2.09253 13.2621C2.4586 13.4486 2.85506 13.5268 3.30905 13.5639C3.75045 13.6 4.29593 13.6 4.97411 13.6H4.97412H4.9999H6.9999H7.02568H7.02569C7.70388 13.6 8.24936 13.6 8.69076 13.5639C9.14474 13.5268 9.5412 13.4486 9.90727 13.2621C10.4906 12.9649 10.9648 12.4907 11.262 11.9074C11.4485 11.5413 11.5268 11.1448 11.5638 10.6908C11.579 10.5056 11.5878 10.3021 11.5929 10.0781L13.9169 11.5307C14.6496 11.9886 15.5999 11.4618 15.5999 10.5979V5.40212C15.5999 4.53814 14.6496 4.01141 13.9169 4.46932L11.5929 5.92185C11.5878 5.69788 11.579 5.49435 11.5638 5.30914C11.5268 4.85516 11.4485 4.45869 11.262 4.09262C10.9648 3.50932 10.4906 3.03508 9.90727 2.73787C9.5412 2.55135 9.14474 2.47314 8.69076 2.43605C8.24936 2.39998 7.70388 2.39999 7.0257 2.39999H6.9999H4.9999ZM11.5999 7.33254V8.66745L14.3999 10.4174V5.58254L11.5999 7.33254ZM10.3999 7.27712V6.99999C10.3999 6.29003 10.3994 5.79364 10.3678 5.40686C10.3368 5.02708 10.2788 4.80612 10.1928 4.63741C10.0107 4.2799 9.71999 3.98924 9.36248 3.80708C9.19378 3.72112 8.97281 3.66309 8.59304 3.63206C8.20626 3.60046 7.70987 3.59999 6.9999 3.59999H4.9999C4.28994 3.59999 3.79355 3.60046 3.40677 3.63206C3.02699 3.66309 2.80603 3.72112 2.63732 3.80708C2.27981 3.98924 1.98915 4.2799 1.80699 4.63741C1.72103 4.80612 1.663 5.02708 1.63197 5.40686C1.60037 5.79364 1.5999 6.29003 1.5999 6.99999V8.99999C1.5999 9.70996 1.60037 10.2064 1.63197 10.5931C1.663 10.9729 1.72103 11.1939 1.80699 11.3626C1.98915 11.7201 2.27981 12.0107 2.63732 12.1929C2.80603 12.2789 3.02699 12.3369 3.40677 12.3679C3.79355 12.3995 4.28994 12.4 4.9999 12.4H6.9999C7.70987 12.4 8.20626 12.3995 8.59304 12.3679C8.97281 12.3369 9.19378 12.2789 9.36248 12.1929C9.71999 12.0107 10.0107 11.7201 10.1928 11.3626C10.2788 11.1939 10.3368 10.9729 10.3678 10.5931C10.3994 10.2064 10.3999 9.70996 10.3999 8.99999V8.72287V7.27712Z" fill="#FAFAFB"/>
							</svg>
							<span>{{this.selectedAIO ?  this.selectedAIO.name : 'Select a stream'}}</span></div>
                        <b-dropdown :disabled="hasLiveSubscription && !hasLiveSubscription.enabled" ref="source" right variant="dark-3" size="md" id="stream-source-aio" menu-class="bg-dark-3 stream-source-menu"
                                    toggle-class="justify-content-between text-truncate" class="w-100">
                                    <b-dropdown-text text-class="px-0">
                                            <div v-if="allInOneStreams.length" class="aio_search">
                                                <b-input-group size="md" class="bg-dark-5 rounded">
                                                    <template #prepend>
                                                        <b-input-group-text class="bg-transparent border-0 text-dark-6">
                                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                                    d="M2.25 6.75C2.25 4.26472 4.26472 2.25 6.75 2.25C9.23528 2.25 11.25 4.26472 11.25 6.75C11.25 9.23528 9.23528 11.25 6.75 11.25C4.26472 11.25 2.25 9.23528 2.25 6.75ZM6.75 0.75C3.43629 0.75 0.75 3.43629 0.75 6.75C0.75 10.0637 3.43629 12.75 6.75 12.75C8.13653 12.75 9.41322 12.2797 10.4292 11.4899L13.9697 15.0303C14.2626 15.3232 14.7374 15.3232 15.0303 15.0303C15.3232 14.7374 15.3232 14.2626 15.0303 13.9697L11.4899 10.4292C12.2797 9.41322 12.75 8.13653 12.75 6.75C12.75 3.43629 10.0637 0.75 6.75 0.75Z"
                                                                    fill="currentColor" />
                                                            </svg>
                                                        </b-input-group-text>
                                                    </template>
                                                    <b-form-input ref="searchWidgetInputElement" placeholder="Search for files" size="md"
                                                        class="border-0" v-model="search"></b-form-input>
                                                    <b-button @click="search = ''" variant="icon" size="md" class="search-clear"
                                                        :class="{ 'active': search.length > 0 }">
                                                        <svg class="text-dark-8" width="16" height="17" viewBox="0 0 16 17" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                                d="M8 15.5C11.866 15.5 15 12.366 15 8.5C15 4.63401 11.866 1.5 8 1.5C4.13401 1.5 1 4.63401 1 8.5C1 12.366 4.13401 15.5 8 15.5ZM6.03033 5.46967C5.73744 5.17678 5.26256 5.17678 4.96967 5.46967C4.67678 5.76256 4.67678 6.23744 4.96967 6.53033L6.93934 8.5L4.96967 10.4697C4.67678 10.7626 4.67678 11.2374 4.96967 11.5303C5.26256 11.8232 5.73744 11.8232 6.03033 11.5303L8 9.56066L9.96967 11.5303C10.2626 11.8232 10.7374 11.8232 11.0303 11.5303C11.3232 11.2374 11.3232 10.7626 11.0303 10.4697L9.06066 8.5L11.0303 6.53033C11.3232 6.23744 11.3232 5.76256 11.0303 5.46967C10.7374 5.17678 10.2626 5.17678 9.96967 5.46967L8 7.43934L6.03033 5.46967Z"
                                                                fill="currentColor" />
                                                        </svg>
                                                    </b-button>
                                                </b-input-group>
                                                
                                            </div>
                                            <div>
                                                <div class="text-center text-s-s text-dark-7 mt-3 mb-1" v-if="allInOneStreams.length === 0">
                                                    Please create an All in One stream.
                                                </div>
                                                <b-list-group v-else class="stream-source-list mt-2">
                                                    <b-list-group-item button variant="dark-3" v-for="(item, index) in  allInOneStreamsFiltered"
                                                        :key="index" @click="setElement(item)"
                                                        class="d-flex align-items-center text-dark-8 px-3 py-2 text-s-s text-truncate flex-shrink-0">
                                                        <svg class="mr-2 flex-shrink-0" width="16" height="12" viewBox="0 0 16 12" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                                d="M4.9999 0.399902H4.97411C4.29592 0.399897 3.75045 0.399892 3.30905 0.435956C2.85506 0.473048 2.4586 0.55126 2.09253 0.737783C1.50923 1.03499 1.03499 1.50923 0.737783 2.09253C0.55126 2.4586 0.473048 2.85506 0.435956 3.30905C0.399892 3.75045 0.399897 4.29592 0.399902 4.97411V4.9999V6.9999V7.0257C0.399897 7.70388 0.399892 8.24936 0.435956 8.69076C0.473048 9.14474 0.55126 9.5412 0.737783 9.90727C1.03499 10.4906 1.50923 10.9648 2.09253 11.262C2.4586 11.4485 2.85506 11.5268 3.30905 11.5638C3.75045 11.5999 4.29593 11.5999 4.97411 11.5999H4.97412H4.9999H6.9999H7.02568H7.02569C7.70388 11.5999 8.24936 11.5999 8.69076 11.5638C9.14474 11.5268 9.5412 11.4485 9.90727 11.262C10.4906 10.9648 10.9648 10.4906 11.262 9.90727C11.4485 9.5412 11.5268 9.14474 11.5638 8.69076C11.579 8.50555 11.5878 8.30202 11.5929 8.07805L13.9169 9.53058C14.6496 9.98849 15.5999 9.46176 15.5999 8.59778V3.40203C15.5999 2.53805 14.6496 2.01132 13.9169 2.46923L11.5929 3.92176C11.5878 3.69779 11.579 3.49426 11.5638 3.30905C11.5268 2.85506 11.4485 2.4586 11.262 2.09253C10.9648 1.50923 10.4906 1.03499 9.90727 0.737783C9.5412 0.55126 9.14474 0.473048 8.69076 0.435956C8.24936 0.399892 7.70388 0.399897 7.0257 0.399902H6.9999H4.9999ZM11.5999 5.33245V6.66735L14.3999 8.41735V3.58245L11.5999 5.33245ZM10.3999 5.27703V4.9999C10.3999 4.28994 10.3994 3.79355 10.3678 3.40677C10.3368 3.02699 10.2788 2.80603 10.1928 2.63732C10.0107 2.27981 9.71999 1.98915 9.36248 1.80699C9.19378 1.72103 8.97281 1.663 8.59304 1.63197C8.20626 1.60037 7.70987 1.5999 6.9999 1.5999H4.9999C4.28994 1.5999 3.79355 1.60037 3.40677 1.63197C3.02699 1.663 2.80603 1.72103 2.63732 1.80699C2.27981 1.98915 1.98915 2.27981 1.80699 2.63732C1.72103 2.80603 1.663 3.02699 1.63197 3.40677C1.60037 3.79355 1.5999 4.28994 1.5999 4.9999V6.9999C1.5999 7.70987 1.60037 8.20626 1.63197 8.59304C1.663 8.97281 1.72103 9.19378 1.80699 9.36248C1.98915 9.71999 2.27981 10.0107 2.63732 10.1928C2.80603 10.2788 3.02699 10.3368 3.40677 10.3678C3.79355 10.3994 4.28994 10.3999 4.9999 10.3999H6.9999C7.70987 10.3999 8.20626 10.3994 8.59304 10.3678C8.97281 10.3368 9.19378 10.2788 9.36248 10.1928C9.71999 10.0107 10.0107 9.71999 10.1928 9.36248C10.2788 9.19378 10.3368 8.97281 10.3678 8.59304C10.3994 8.20626 10.3999 7.70987 10.3999 6.9999V6.72278V5.27703Z"
                                                                fill="currentColor" />
                                                        </svg>
                                                        <span class="d-block text-truncate">{{ item.name }}</span>
                                                    </b-list-group-item>
                                                </b-list-group>
                                            </div>
                                    </b-dropdown-text>
                                </b-dropdown>
                            </b-col>
                    </b-row>
				<b-row class="px-3 mt-3">
					<b-col>
						<div style="max-width: 300px;margin-left:auto;margin-right: 0;">
							<div class="text-center d-flex align-items-center justify-content-end mt-3 create-highlight">
								<b-button variant="outline-secondary" size="md" class="w-100 mb-0 mb-md-0 mr-2"
									@click="closeModal">
									Cancel
								</b-button>
								<b-button :disabled="(!this.highlightAllowed || !this.selectedAIO)"  @click="onConfirm" variant="primary" size="md" class="w-100 mt-0">
									Create Live Clipping
								</b-button>
							</div>
						</div>
					</b-col>
				</b-row>
			</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import _ from 'lodash';
import Spinner from "@/components/ui/Spinner.vue"
import { mapGetters } from 'vuex'
import HighlightService from '@/services/HighlightService'

export default {
	name: 'AddHighlightModal',
	components: {
		Spinner
	},
	data() {
		return {
			highlightName: '',
			error: null,
			exists: [],
            selectedAIO: null,
            search: '',
		};
	},
	props: {
		highlight: {
			type: Array,
		},
	},
	computed: {
        ...mapGetters({
			hasLiveSubscription: "User/hasLiveSubscription",
            allInOneStreams: "Streams/allInOneStreams",
			subscriptions: "User/subscriptions",
			loadingStatus: "Ui/loadingStatus",
		}),
        allInOneStreamsFiltered() {
			const allInOneStreams = _.cloneDeep(this.allInOneStreams.filter(stream => stream.name.toLowerCase().includes(this.search.toLowerCase())))
			return allInOneStreams.sort(function (a, b) {
				return new Date(b.creationTime) - new Date(a.creationTime)
			})
		},
		highlightAllowed() {
			return (this.highlightName.length > 0) && this.isAccessHighlight && (this.highlight.length < this.isAccessHighlight);
		},
		isAccessHighlight() {
			let sub = null
			this.subscriptions.some((item) => {
				if (item.enabled && item.category === 'live') sub = item
			})
			let isValidPlanOverrideDefinition = null
			let isValidPlanDefinition = false
			if (sub) {
				if (sub?.package?.definition?.maxHighlightCount) isValidPlanDefinition = sub.package.definition.maxHighlightCount
				if (sub?.definitionOverride?.maxHighlightCount) isValidPlanOverrideDefinition = sub.definitionOverride.maxHighlightCount
			}
			if (isValidPlanOverrideDefinition) return isValidPlanOverrideDefinition
			return isValidPlanDefinition
		},
	},
	async mounted() {
        await this.$store.dispatch('Streams/getStreams');
	},
	methods: {
		async onConfirm() {
			try {
				this.$store.dispatch('Ui/setLoadingStatus', true);
					const newHighlight = await HighlightService.createHighlight(
						this.highlightName,
                        '',
						this.selectedAIO._id
					);
                    this.$emit('highlight-created', newHighlight)
                    console.log(newHighlight);
					this.$notify({ group: 'success', text: 'New Live Clipping Created' })
					
                    this.$store.dispatch('Ui/setLoadingStatus', false)
					await this.$store.dispatch('Highlight/getHighlight')

                    this.closeModal();
					
				// }
				
			} catch (err) {
				this.error = err.message
				// this.$store.dispatch('Ui/setLoadingStatus', false)
			}
		},
        async setElement(item) {
            this.selectedAIO = item;
            console.log(item);
            this.$refs.source.hide()
			// try {

			// } catch (err) {
			// 	console.log(err)
			// }
		},
		closeModal() {
			this.playlistName = ''
			this.selectedAIO = null;
			this.$refs['modalAddHighlight'].hide()
		},
		onReset() {
			this.error = null
		}
	}
};
</script>

<style scoped>
.selected-stream--name {
    position: absolute;
    left: 25px;
    top: 37px;
    z-index: 9;
	color: var(--c-text-9);
	pointer-events: none;
	display: flex;
	align-items: center;
}
.selected-stream--name.stream-selected {
	color: var(--c-text-2);
}

#stream-source-aio{
	height: 32px;
	    background: #404B72;
    border-radius: 6px;
    box-shadow: 0px 0.5px 0px 0px rgba(255, 255, 255, 0.08) inset, 0px 1px 1px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.04), 0px 12px 16px 0px rgba(0, 0, 0, 0.06);
}
#modal-add-highlight___BV_modal_content_ input {
    height: 32px;
}
#modal-add-highlight___BV_modal_content_ input::placeholder{
	color: #8794B5;
	font-size: var(--font-s-ss);
}
.highlight-quota-exceeded{
	padding: 6px 12px;
	border-radius: 6px;
    background: var(--secondary-warning, #E2A052);
    width: calc(100% - 30px);
    margin: 0 auto;
    margin-bottom: 15px;

}
@media (max-width: 767px) {}
</style>
